import React from "react";
import ReactApexChart from "react-apexcharts";
import { lineBarChartData } from "../MockData";

function LineBarChart({ width = "100%", height = 400 }) {
  const options = {
    chart: {
      type: "line",
      height: height,
      stacked: false,
    },
    stroke: {
      width: [0, 4], // bar = 0px border, line = 4px
    },
    dataLabels: {
      enabled: true,
      enabledOnSeries: [1], // only show data labels on line
    },
    labels: lineBarChartData.labels,
    xaxis: {
      categories: lineBarChartData.labels,
    },
    yaxis: [
      {
        title: {
          text: "Sales",
        },
      },
      {
        opposite: true,
        title: {
          text: "Growth (%)",
        },
      },
    ],
    legend: {
      position: "top",
    },
    tooltip: {
      shared: true,
      intersect: false,
    },
  };

  return (
    <ReactApexChart
      options={options}
      series={lineBarChartData.series}
      type="line"
      height={height}
      width={width}
    />
  );
}

export default LineBarChart;
